import styled from 'styled-components';
import { buttonSize } from '../AddButton';

export default styled.div`
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: ${buttonSize};
  text-align: center;
  display: grid;
  align-content: center;
  justify-content: center;
`;
